var $ = require('jquery');
require('./cookie.js');
var isThunder = / Thunder/.test(navigator.userAgent);

$(function() {
	if (isThunder) {
		xl9.api.onUserLogout(function() {
			location.reload();
		});
		xlQuickLogin.setLoginExt(function(){

	    });
	} else {
		xlQuickLogin.init({
			loginID: '101',
			registerID: 'act',
			UI_THEME: 'popup',
			// 登录成功后回调函数，当 SET_ROOT_DOMAIN == true 时该项可用
			LOGIN_SUCCESS_FUNC: function() {
				window.loginInit();
			},
			// 注册成功后回调函数，当 SET_ROOT_DOMAIN == true 时该项可用
			REGISTER_SUCCESS_FUNC: function() {
				location.reload();
			},
			// 关闭按钮回调函数，只适用弹窗主题
			POPUP_CLOSE_FUNC: function() {},
			//登出后的回调
			LOGOUT_FUNC: function() {
				location.reload();
			}
		});
	}
});

function login() {
	if (isThunder) {
		xl9.api.showLoginDlg(function(err) {});
	} else {
		xlQuickLogin.popup();
	}
}

function haslogin() {
	return getRealCookie('sessionid') && getRealCookie('userid')
}

function logout() {
	clearCookie();
	if (isThunder) {
		xl9.api.logout(function(err) {

		});
	} else {
		xlQuickLogin.logout();
	}
}

$.live('.login', function() {
	login();
});

$.live('.logout', function() {
	logout();
});

window.haslogin = haslogin;
window.login = login;
window.logout = logout;
module.exports = {
	login: login,
	logout: logout,
	haslogin: haslogin
};



//////////////////
// WEBPACK FOOTER
// ./src/common/login.js
// module id = 4
// module chunks = 0